import { useState, useEffect } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import Swal from "sweetalert2";
import { EntrenamientoIcon } from "../../Icons/CollaboratorsIcons";
import ModalAddTraining from "./Components/ModalAddTraining/ModalAddTraining";

import "./Training.sass";
import { getCandidateKnowledges, updateCandidateKnowledges } from "../../API/Candidates/Training";
import SkillsAcordion from "./Components/SkillsAcordion/SkillsAcordion";
import { myKnowledgeTranslate } from "../../i18n/translatedMessages";

const B2EEntrenamiento = () => {
  const [show, setShow] = useState(false);
  const [dataLanguages, setDataLanguages] = useState([]);
  const [dataSkills, setDataSkills] = useState([]);
  const [knowledgesToSend, setKnowledgesToSend] = useState([]);
  const [isClick, setIsClick] = useState(false);

  useEffect(() => {
    async function getKnowledgesCandidate() {
      const data = await getCandidateKnowledges(localStorage.getItem("candidateId"));
      if (data?.items?.languages?.length > 0 || data?.items?.skills?.length > 0) {
        setDataLanguages(data.items.languages);
        setDataSkills(data.items.skills);
      }
    }
    getKnowledgesCandidate();
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const handleChange = (index, newLevel, typeRadio) => {
    if (typeRadio === "skills") {
      const newDataSkills = [...dataSkills];

      const newSkillLevelId = newLevel;
      newDataSkills[index] = {
        ...newDataSkills[index],
        skill_level_id: parseInt(newSkillLevelId),
      };
      setDataSkills(newDataSkills);
    }
    if (typeRadio === "language") {
      const newDataLanguages = [...dataLanguages];

      const newLanguageLevelId = newLevel;
      newDataLanguages[index] = {
        ...newDataLanguages[index],
        language_level_id: parseInt(newLanguageLevelId),
      };
      setDataLanguages(newDataLanguages);
    }
  };

  useEffect(() => {
    handleSend(isClick);
  }, [knowledgesToSend]);

  const handleSend = async (click) => {
    if (click) {
      const resp = await updateCandidateKnowledges(
        localStorage.getItem("candidateId"),
        knowledgesToSend
      );
      if (resp.status < 200 || resp.status > 299) {
        if (resp.status > 399 && resp.status < 500) {
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "Algo ha ido mal, verifique os datos mas una vez!",
          });
          setIsClick(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Algo ha ido mal, inténtelo de nuevo más tarde!",
          });
          setIsClick(false);
        }
      } else {
        Swal.fire({
          icon: "success",
          title: "Listo",
          text: "Actualizado con Éxito!",
        });
        setIsClick(false);
      }
    } else {
      await updateCandidateKnowledges(localStorage.getItem("candidateId"), knowledgesToSend);
      setIsClick(false);
    }
  };

  const handleAdd = (dataModal) => {
    if (
      dataModal.courseName === "" ||
      dataModal.typeOfSkill === "" ||
      !("radioLevel" in dataModal)
    ) {
      Swal.fire({
        title: "Complete todos los campos",
        icon: "warning",
      });
    } else {
      if (dataModal.typeOfSkill === "language") {
        const newDataLanguage = [...dataLanguages];
        const newLanguage = {
          language: dataModal.courseName,
          language_level_id: parseInt(dataModal.radioLevel),
          certificate_url: "0",
        };
        setIsClick(true);
        newDataLanguage.push(newLanguage);
        setDataLanguages(newDataLanguage);
      } else {
        const newDataSkills = [...dataSkills];
        const newSkill = {
          name: dataModal.courseName,
          skill_level_id: parseInt(dataModal.radioLevel),
          certificate_url: "0",
        };
        setIsClick(true);
        newDataSkills.push(newSkill);
        setDataSkills(newDataSkills);
      }
      setShow(false);
    }
  };

  useEffect(() => {
    setKnowledgesToSend((prevKnowledgesToSend) => ({
      ...prevKnowledgesToSend,
      languages: dataLanguages ? dataLanguages : null,
      capacitations: dataSkills ? dataSkills : null,
    }));
  }, [dataLanguages, dataSkills]);

  const handleRemove = async (typeOfKnowledge, index) => {
    if (typeOfKnowledge === "language") {
      const newLanguages = [...dataLanguages];
      newLanguages.splice(index, 1);
      setDataLanguages(newLanguages);
    }
    if (typeOfKnowledge === "skill") {
      const newSkill = [...dataSkills];
      newSkill.splice(index, 1);
      setDataSkills(newSkill);
    }
  };

  return (
    <div className="container-fluid sideMenuSeparator color-grey training-main">
      <ModalAddTraining
        handleAdd={handleAdd}
        show={show}
        handleClose={handleClose}
        handleSend={handleSend}
      />
      <div className="row mb-4 align-items-center">
        <div className="col-2">
          <span className="title-icon p-2 m-auto">
            <EntrenamientoIcon size={2} />
          </span>
        </div>
        <div className="col-10">
          <h1>{myKnowledgeTranslate.myKnowledgeTitle}</h1>
          <p className="description-section">{myKnowledgeTranslate.myKnowledgeText}</p>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="row">
          <div className="ms-auto col-12 text-end">
            <button className="btn training-add-btn align-items-center" onClick={handleShow}>
              {myKnowledgeTranslate.assignKnowledge} <AiOutlinePlusCircle size={18} />
            </button>
          </div>
        </div>
        <div className="col-12">
          <div className="container">
            <SkillsAcordion
              dataLanguages={dataLanguages}
              dataSkills={dataSkills}
              handleChange={handleChange}
              handleSend={handleSend}
              handleRemove={handleRemove}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default B2EEntrenamiento;
